// extracted by mini-css-extract-plugin
export default {"name":"project-table_name__qGlM6","name__icon":"project-table_name__icon__ISPCs","name__text":"project-table_name__text__LP-OI","rowContent":"project-table_rowContent__PUQHy"};